import {connect} from 'react-redux';
import Divisions from './Divisions.jsx';
import {
  handleDivisionClick,
  handleEventClick,
  handleVirtualEventClick,
  handeNewDivisionClick
} from './actions';
  
const mapStateToProps = state => ({
  eventIdSelected: state.tournament.divisions.eventIdSelected,
  virtualEventIdSelected: state.tournament.divisions.virtualEventIdSelected,
  selectedEventName: state.tournament.divisions.selectedEventName,
  events: state.tournament.divisions.events,
  virtualEvents: state.tournament.divisions.virtualEvents,
  divisions: state.tournament.divisions.divisions,
  canCreateDivision: state.tournament.base.tournamentInfo.canCreateDivision
});

const mapDispatchToProps = dispatch => ({
  onEventClick: eventId => dispatch(handleEventClick(eventId)),
  onVirtualEventClick: virtualEventId => dispatch(handleVirtualEventClick(virtualEventId)),
  onDivisionClick: divisionId => dispatch(handleDivisionClick(divisionId)),
  onNewDivisionClick: () => dispatch(handeNewDivisionClick())
});

export default connect(mapStateToProps, mapDispatchToProps)(Divisions);



// WEBPACK FOOTER //
// ./src/features/tournament/divisions/DivisionsContainer.jsx